<template>
    <b-container class="container-register" fluid>
        <b-row align-h="center" class="mt-5">
            <img src="@/assets/images/logo.png" href="/" alt="">
        </b-row>
        <b-row align-h="center" class="mt-4">
            <p class="subtitle-register">BIENVENIDO AL PORTAL DE SIMULACROS DE LA UNIVERSIDAD CATOLICA SAN PABLO </p>
        </b-row>
        <b-row align-h="center" v-if="key!='LAN20'">
            <p class="subtitle-register">Elige el Examen Simulacro al que deseas acceder</p>
        </b-row>
        <Simulacros :select="1" :url="url"/>
    </b-container>
</template>
<script>
    import Simulacros from '@/components/Global/Simulacros'

    export default {
        name: 'Simulacros1',
        components: {
            Simulacros
        },
        data: () => ({
            url: 'Instruccion',
            key: localStorage.getItem('idkey')
        }),
        created() {

        },
    }
</script>
<style scoped>
</style>